import { GeneralService } from "./GeneralService";
import { ApiKeyOrGetter } from "./GeneralService";
import { FinetuneRunNew, FinetuneRunStatus } from "../model_gen/finetuning";

export class FinetuneRunService {
  public static getFinetuneRuns(
    offset: number = 0,
    limit: number = 10,
    loadingHandler: ((val: boolean) => void) | undefined,
    apiKey: ApiKeyOrGetter,
    statuses?: FinetuneRunStatus[]
  ) {
    const statusParams = statuses?.length
      ? statuses.map((s) => `status[]=${encodeURIComponent(s)}`).join("&")
      : "";
    const url = `/finetune_runs/?offset=${offset}&limit=${limit}${
      statusParams ? `&${statusParams}` : ""
    }`;
    return GeneralService.get(
      url,
      loadingHandler,
      JSON,
      GeneralService.PROD_ENDPOINT,
      apiKey
    );
  }

  public static getFinetuneRunsByCompositionId(
    compositionId: number,
    offset: number = 0,
    limit: number = 10,
    loadingHandler: ((val: boolean) => void) | undefined,
    apiKey: ApiKeyOrGetter
  ) {
    return GeneralService.get(
      `/finetune_runs/composition/${compositionId}?offset=${offset}&limit=${limit}`,
      loadingHandler,
      JSON,
      GeneralService.PROD_ENDPOINT,
      apiKey
    );
  }

  public static createFinetuneRun(
    finetuneRun: FinetuneRunNew,
    loadingHandler: ((val: boolean) => void) | undefined,
    apiKey: ApiKeyOrGetter
  ) {
    return GeneralService.post(
      "/finetune_runs/",
      JSON.stringify(finetuneRun),
      loadingHandler,
      JSON,
      GeneralService.PROD_WEST_ENDPOINT,
      apiKey
    );
  }

  public static getFinetuneRunById(
    runId: number,
    loadingHandler: ((val: boolean) => void) | undefined,
    apiKey: ApiKeyOrGetter
  ) {
    return GeneralService.get(
      `/finetune_runs/${runId}`,
      loadingHandler,
      JSON,
      GeneralService.PROD_ENDPOINT,
      apiKey
    );
  }

  public static deployFinetuneRunPredibase(
    runId: number,
    modelName: string,
    loadingHandler: ((val: boolean) => void) | undefined,
    apiKey: ApiKeyOrGetter
  ) {
    return GeneralService.post(
      `/finetune_runs/${runId}/deploy/predibase`,
      JSON.stringify({ model_name: modelName }),
      loadingHandler,
      JSON,
      GeneralService.PROD_ENDPOINT,
      apiKey
    );
  }

  public static deployFinetuneRunGroq(
    runId: number,
    modelName: string,
    loadingHandler: ((val: boolean) => void) | undefined,
    apiKey: ApiKeyOrGetter
  ) {
    return GeneralService.post(
      `/finetune_runs/${runId}/deploy/groq`,
      JSON.stringify({ model_name: modelName }),
      loadingHandler,
      JSON,
      GeneralService.PROD_ENDPOINT,
      apiKey
    );
  }
  public static deployFinetuneRunVast(
    runId: number,
    modelName: string,
    loadingHandler: ((val: boolean) => void) | undefined,
    apiKey: ApiKeyOrGetter
  ) {
    return GeneralService.post(
      `/finetune_runs/${runId}/deploy/vast`,
      JSON.stringify({ model_name: modelName }),
      loadingHandler,
      JSON,
      GeneralService.PROD_ENDPOINT,
      apiKey
    );
  }

  public static retryFinetuneRun(
    runId: number,
    heavy: boolean = false,
    loadingHandler: ((val: boolean) => void) | undefined,
    apiKey: ApiKeyOrGetter
  ) {
    return GeneralService.post(
      `/finetune_runs/${runId}/retry`,
      JSON.stringify({ heavy }),
      loadingHandler,
      JSON,
      GeneralService.PROD_WEST_ENDPOINT,
      apiKey
    );
  }

  public static cancelFinetuneRun(
    runId: number,
    loadingHandler: ((val: boolean) => void) | undefined,
    apiKey: ApiKeyOrGetter
  ) {
    return GeneralService.post(
      `/finetune_runs/${runId}/cancel`,
      JSON.stringify({}),
      loadingHandler,
      JSON,
      GeneralService.PROD_ENDPOINT,
      apiKey
    );
  }
}
